import { render, staticRenderFns } from "./certificateApply.vue?vue&type=template&id=70db307c&scoped=true&"
import script from "./certificateApply.vue?vue&type=script&lang=js&"
export * from "./certificateApply.vue?vue&type=script&lang=js&"
import style0 from "./certificateApply.vue?vue&type=style&index=0&id=70db307c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70db307c",
  null
  
)

export default component.exports